import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { empModulo } from '../../../diccionarios/empModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ResponseRequisicionModel } from '../../../models/responseRequisicionModel';
import { ReportesService } from '../../../services/administrador/reportes.service';
import { EmpleadoModel } from '../../../models/empleadoModel';
import { CrearEmpleadoService } from '../../../services/administrador/crear-empleado.service';
import { EmpresasModel } from '../../../models/empresasModel';
import { CatalogoService } from 'src/app/aplicaciones-modulos/epp/services/catalogo.service';

@Component({
  selector: 'app-control-empresa',
  templateUrl: './control-empresa.component.html',
  styleUrls: ['./control-empresa.component.css']
})
export class ControlEmpresaComponent implements OnInit {

  EmpleadoModal: any = { nombres: '' , cedula : '' };
 
  empModulo: any = {};
  formulario: FormGroup;//formulario
  
  loading: boolean = false;
  listaVacia: boolean = true;
  mostrarCard: boolean = true;
  resposiveFull: string;

  columnDefs: any[];//aggrid
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  textoBuscar: string;
  
  dataEdit: any = {};
  arrayEdit: any[] = [];

  cmbEmpresas:EmpresasModel[] = [];
  formularioEmp: FormGroup;
  cmbLocalidad: any;
  cmbDepartamentoSolicita: any[] = [];
  cmbEmpleadoSolicita: any[];

  cmbEmpresaSolicita: EmpresasModel[] = [];
  selectedRowsEdit: any[] = [];
  classEdit: string = 'btn btn-outline-success btn-block';
  formularioEmpMultiple: FormGroup;

  depSolicita = 'Departamento Solicita';
  empSolicitante = 'Empleado Solicitante';
  codEmpresa: any = {};
  claseLabel: string = '';

  accesoIESS: boolean = false;
  statusCheck: string;

  accesoIESSMul: boolean = false;
  statusCheckMul: string;
  
  docIess: any;
  docIessMul: any;
  // cmbAccesoIESS: { clave: string; valor: string; }[];

  constructor(private fb: FormBuilder, private _util: UtilsService, private _reporteService: ReportesService,  private _crearEmpleado: CrearEmpleadoService,private _catalogo: CatalogoService) { }

  ngOnInit() {
    this.empModulo = empModulo;
    this.resposiveFull = this.empModulo.div.resposiveFull;
    this.formulario = this.fb.group({
      codigoEmpresa: ['', [Validators.required]],
    });
    this.formularioEmp = this.fb.group({
      codEmpleado: ['', [Validators.required]],
      fechaIngreso: ['', [Validators.required]],
      fechaSalida: ['', [Validators.required]],
      codLocalidad: ['', [Validators.required]],
      empresaSolicita: ['', [Validators.required]],
      departamentoSolicita: ['', [Validators.required]],
      empleadoSolicita: ['', [Validators.required]],
      accesoIESS: ['', [Validators.required]]
    });
    this.formularioEmpMultiple = this.fb.group({
      fechaIngreso: ['', [Validators.required]],
      fechaSalida: ['', [Validators.required]],
      codLocalidad: ['', [Validators.required]],
      empresaSolicita: ['', [Validators.required]],
      departamentoSolicita: ['', [Validators.required]],
      empleadoSolicita: ['', [Validators.required]],
      accesoIESS: ['', [Validators.required]]
    });
    this.cargarGrid();
    this.getAllEmpresas();
    this.getAllLocalidads();
    this.getAllEmpresaSolicita();
    this.codEmpresa = this._catalogo.getCodEmpreFabril();
    // this.cmbAccesoIESS = this._catalogo.catalogoAccesoIESS();
    this.formularioEmp.get('accesoIESS').setValue(this.accesoIESS);
    this.formularioEmpMultiple.get('accesoIESS').setValue(this.accesoIESSMul);
    setTimeout(() => {
      this.docIess = document.getElementById('docIess') as HTMLInputElement;
      this.docIess.checked = false;
      this.docIessMul = document.getElementById('docIessMul') as HTMLInputElement;
      this.docIessMul.checked = false;
    }, 200);
  }

  setCheckForm(value) {
    if(value){
      this.accesoIESS = false;
      this.statusCheck = ""
      this.docIess.checked = false;
    } else {
      this.accesoIESS = true;
      this.statusCheck = "Activo"
      this.docIess.checked = true;
    }
    this.formularioEmp.get('accesoIESS').setValue(this.accesoIESS);
  }

  setCheckFormMul(value) {
    if(value){
      this.accesoIESSMul = false;
      this.statusCheckMul = ""
      this.docIessMul.checked = false;
    } else {
      this.accesoIESSMul = true;
      this.statusCheckMul = "Activo"
      this.docIessMul.checked = true;
    }
    this.formularioEmpMultiple.get('accesoIESS').setValue(this.accesoIESSMul);
  }

  getData(event) {
    //getAllEmpleadoEmpresa
    this.loading = true;
    this._crearEmpleado.getAllEmpleadoEmpresa(this.formulario.get('codigoEmpresa').value).subscribe((res: any[]) => {
      this.rowData = res;
      this.loading = false;
      this.listaVacia = (res.length === 0 ) ? true : false;
    }, (err) => {
      this.rowData = [];
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErroToast(err.error.message, 2000);
      console.log(err);
    });
  }

  getAllEmpresaSolicita() {
    this._crearEmpleado.getAllEmpresaSolicita().subscribe((res: any) => {
      this.cmbEmpresaSolicita = res;
    }, (err) => {
      console.log(err);
      console.log('No se ecnontro al empleado');
    });
  }

  getAllEmpresas() {
    this._crearEmpleado.getAllEmpresas().subscribe((res: EmpresasModel[]) => {
      //this.cmbEmpresas = res;
      this.cmbEmpresas = res.sort((a, b) => (a.descripcion < b.descripcion ? -1 : 1));
    }, (err) => {
      this.cmbEmpresas = [];
      // this._util.mensajeErroToast(err.error.message, 2000);
      console.log(err);
    });
  }

  getAllLocalidads() {
    this._crearEmpleado.getAllLocalidades().subscribe((res: any[]) => {
      this.cmbLocalidad = res;
      this.cmbLocalidad = this.cmbLocalidad.map((e)=>{
        e.id = e.pk.codigo;
        return e;
      });
    }, (err) => {
      this.cmbLocalidad = [];
      console.log(err);
    });
  }

  selecionEmpresaSolicita() {
    this.changeEmpresaSolicita();
    let empresaSolicita = this.formularioEmp.get('empresaSolicita').value;
    this.cmbDepartamentoSolicita = [];
    // let codigoEmpresa = this.formulario.get('codigoEmpresa').value;
    this._crearEmpleado.getDepartamentoByEmpresa(empresaSolicita).subscribe((res: any) => {
      this.cmbDepartamentoSolicita = res;
      this.getAllEmpleadoEmpresa();
      if(this.cmbDepartamentoSolicita.length === 0) {
        this._util.mensajeErroToast('No se encontró al Departamento a partir de la empresa', 3000);
      } else {
        this.cmbDepartamentoSolicita = this.cmbDepartamentoSolicita.map((e)=>{
          e.id = e.pk.codigo; 
          return e;
        });
      }
    }, (err) => {
      this.getAllEmpleadoEmpresa();
      this.cmbDepartamentoSolicita = [];
      this._util.mensajeErroToast('No se encontró al Departamento a partir de la empresa', 3000);
      console.log(err);
      console.log('No se encontró al Departamento a partir de la empresa');
    });
  }

  selecionDepartamentoSolicita() {
    let departamentoSolicita = this.formularioEmp.get('departamentoSolicita').value;
    // let codigoEmpresa = this.formulario.get('codigoEmpresa').value;
    let empresaSolicita = this.formularioEmp.get('empresaSolicita').value;
    this._crearEmpleado.getEmployesByDepEmpColaborador(departamentoSolicita, empresaSolicita).subscribe((res: any) => {
    // this._crearEmpleado.getEmpleadosByDepAndEmp(departamentoSolicita, empresaSolicita).subscribe((res: any) => {
      this.cmbEmpleadoSolicita = res;
    }, (err) => {
      this.cmbEmpleadoSolicita = [];
      console.log(err);
      console.log('No se encontro Empleados a partir de la empresa y departamento');
    });
  }

  selecionEmpresaSolicitaMul() {
    this.changeEmpresaSolicitaMul();
    let empresaSolicita = this.formularioEmpMultiple.get('empresaSolicita').value;
    this.cmbDepartamentoSolicita = [];
    // let codigoEmpresa = this.formulario.get('codigoEmpresa').value;
    this._crearEmpleado.getDepartamentoByEmpresa(empresaSolicita).subscribe((res: any) => {
      this.cmbDepartamentoSolicita = res;
      this.getAllEmpleadoEmpresaMult();
      if(this.cmbDepartamentoSolicita.length === 0) {
        this._util.mensajeErroToast('No se encontró al Departamento a partir de la empresa', 3000);
      } else {
        this.cmbDepartamentoSolicita = this.cmbDepartamentoSolicita.map((e)=>{
          e.id = e.pk.codigo; 
          return e;
        });
      }
    }, (err) => {
      this.getAllEmpleadoEmpresaMult();
      this.cmbDepartamentoSolicita = [];
      this._util.mensajeErroToast('No se encontró al Departamento a partir de la empresa', 3000);
      console.log(err);
      console.log('No se encontró al Departamento a partir de la empresa');
    });
  }

  getAllEmpleadoEmpresaMult() {
    // debugger
    // this.mainEmpresaSolicita = this.findCmbGenericArray(this.cmbEmpresa, this.formulario.get('empresaSolicita').value);
    this._crearEmpleado.empleadoEmpresaColaborador(this.formularioEmpMultiple.get('empresaSolicita').value).subscribe((res:any)=>{
    // this._crearEmpleado.getAllEmpleadoEmpresa(this.formularioEmpMultiple.get('empresaSolicita').value).subscribe((res:any)=>{
      this.cmbEmpleadoSolicita = res;
    },(err:any)=>{
      this.cmbEmpleadoSolicita = [];
    });
  }

  getAllEmpleadoEmpresa() {
    debugger
    // this.mainEmpresaSolicita = this.findCmbGenericArray(this.cmbEmpresa, this.formulario.get('empresaSolicita').value);
    // this._crearEmpleado.getAllEmpleadoEmpresa(this.formularioEmp.get('empresaSolicita').value).subscribe((res:any)=>{
    this._crearEmpleado.empleadoEmpresaColaborador(this.formularioEmp.get('empresaSolicita').value).subscribe((res:any)=>{
      this.cmbEmpleadoSolicita = res;
    },(err:any)=>{
      this.cmbEmpleadoSolicita = [];
    });
  }

  selecionDepartamentoSolicitaMul() {
    let departamentoSolicita = this.formularioEmpMultiple.get('departamentoSolicita').value;
    // let codigoEmpresa = this.formulario.get('codigoEmpresa').value;
    let empresaSolicita = this.formularioEmpMultiple.get('empresaSolicita').value;
    // this._crearEmpleado.getEmpleadosByDepAndEmp(departamentoSolicita, empresaSolicita).subscribe((res: any) => {
    this._crearEmpleado.getEmployesByDepEmpColaborador(departamentoSolicita, empresaSolicita).subscribe((res: any) => {
      this.cmbEmpleadoSolicita = res;
    }, (err) => {
      this.cmbEmpleadoSolicita = [];
      console.log(err);
      console.log('No se encontro Empleados a partir de la empresa y departamento');
    });
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Cédula',
        field: 'cedula',
        filter: true,
        width: 180,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombres',
        field: 'nombres',
        sortable: true,
        filter: true,
        width: 250,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción empresa',
        field: 'empresa.descripcion',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Ingreso',
        field: 'fechaIngreso',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Salida',
        field: 'fechaSalida',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha',
        field: 'fechaPrimerContrato',
        filter: true,
        width: 150,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción Localidad',
        field: 'dscaLocalidad',
        sortable: true,
        filter: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Deapartamento solcitante',
        field: 'departamentoSolicita',//'departamentoSolicitaDsca',
        sortable: true,
        filter: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Empleado solicitante',
        field: 'empleadoSolicita',//'empleadoSolicitaDsca',
        sortable: true,
        filter: true,
        width: 280,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.callModal.bind(this),
          label: 'Ver',//this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-success'//'btn btn-danger btn btn-block'
        }
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  onSelectionChanged() {
    this.selectedRowsEdit = this.gridApi.getSelectedRows();
    this.classEdit = (this.selectedRowsEdit.length === 0)? 'btn btn-outline-success btn-block' : 'btn btn-success btn-block';
  }

  changeCellColor(params) {
    let data = params.data;
    if (data.info != undefined) {
      if (data.info === 'false') {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return false
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.modificado != undefined) {
      if (data.modificado === true) {
        return {
          'background-color': 'yellow',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return false;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  callModal({ rowData }) {
    // debugger
    this.EmpleadoModal = rowData;
    this.formularioEmp.get('codEmpleado').setValue((rowData.codEmpleado === undefined)? '' : (rowData.codEmpleado === '')? '': rowData.codEmpleado);
    this.formularioEmp.get('fechaIngreso').setValue((rowData.fechaIngreso === undefined)? '' : (rowData.fechaIngreso === '')? '': rowData.fechaIngreso);
    this.formularioEmp.get('fechaSalida').setValue((rowData.fechaSalida === undefined)? '' : (rowData.fechaSalida === '')? '': rowData.fechaSalida);
    this.formularioEmp.get('codLocalidad').setValue((rowData.codLocalidad === undefined)? '' : (rowData.codLocalidad === '')? '': rowData.codLocalidad);
    this.formularioEmp.get('empresaSolicita').setValue((rowData.empresaSolicita === undefined)? '' : (rowData.empresaSolicita === '')? '': rowData.empresaSolicita);
    this.formularioEmp.get('departamentoSolicita').setValue((rowData.departamentoSolicita === undefined)? '' : (rowData.departamentoSolicita === '')? '': rowData.departamentoSolicita);
    this.formularioEmp.get('empleadoSolicita').setValue((rowData.empleadoSolicita === undefined)? '' : (rowData.empleadoSolicita === '')? '': rowData.empleadoSolicita);
    // if( (rowData.accesoIESS === 'Activo') || (rowData.accesoIESS === 'Inactivo')) {
    //   this.formularioEmp.get('accesoIESS').setValue((rowData.accesoIESS === undefined)? '' : (rowData.accesoIESS === '')? '': rowData.accesoIESS);
    // } else { this.formularioEmp.get('accesoIESS').setValue(false);}
    this.formularioEmp.get('accesoIESS').setValue(false);
    this.docIess.checked = false;
    this.statusCheck = '';
    this.selecionEmpresaSolicita();
    this.selecionDepartamentoSolicita();
    document.getElementById('abrirModal').click();
  }

  callModalMultiple() {
    this.formularioEmpMultiple.reset();
    this.statusCheckMul = '';
    this.formularioEmpMultiple.get('accesoIESS').setValue(false);
    this.docIessMul.checked = false;
    document.getElementById('abrirModalMuiltiple').click();
  }

  updateEmpleado() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea actualizar el siguiente colaborador ?',
        text: '',
        action: 'Actualizar',
        funcion: this._crearEmpleado.updateEmpleadoCustom(this.formularioEmp.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      let codigoEmpresa = this.formulario.get('codigoEmpresa').value;
      this.formularioEmp.reset();
      document.getElementById('cerrarModal').click();
      this.formulario.get('codigoEmpresa').setValue(codigoEmpresa);
      this.formularioEmp.get('accesoIESS').setValue(false);
      this.statusCheck = '';
      this.docIess.checked = false;
      this.getData({});
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

  async updateEmpleadoMultiple() {
    let dataEnviar = [];
    for (let i = 0; i < this.selectedRowsEdit.length; i++) {
      const e = this.selectedRowsEdit[i];
      dataEnviar.push({
        codEmpleado: e.codEmpleado,
        fechaIngreso: this.formularioEmpMultiple.get('fechaIngreso').value,
        fechaSalida: this.formularioEmpMultiple.get('fechaSalida').value,
        codLocalidad: this.formularioEmpMultiple.get('codLocalidad').value,
        empresaSolicita: this.formularioEmpMultiple.get('empresaSolicita').value,
        departamentoSolicita: this.formularioEmpMultiple.get('departamentoSolicita').value,
        empleadoSolicita: this.formularioEmpMultiple.get('empleadoSolicita').value,
        accesoIESS: this.formularioEmpMultiple.get('accesoIESS').value
      })
    }
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea actualizar los siguientes registros?',
        text: '',
        action: 'Actualizar',
        funcion: this._crearEmpleado.updateEmpleadoCustomList(dataEnviar),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      let codigoEmpresa = this.formulario.get('codigoEmpresa').value;
      this.formularioEmpMultiple.reset();
      document.getElementById('cerrarModalMultiple').click();
      this.formulario.get('codigoEmpresa').setValue(codigoEmpresa);
      this.formularioEmpMultiple.get('accesoIESS').setValue(false);
      this.statusCheckMul = '';
      this.docIessMul.checked = false;
      this.getData({});
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

  async saveDataServices(obj: any) {
     return new Promise(async ( resolve, reject )=>{
      await this._crearEmpleado.updateEmpleadoCustom(obj).subscribe((res:any)=>{
        resolve(res);
      },(err:any)=>{
        reject(err);
      });
     });
  }

  changeClearSolicitados(event) {
    this.formularioEmp.get('departamentoSolicita').setValue('');
    this.formularioEmp.get('empleadoSolicita').setValue('');
  }

  changeClearEmpleado() {
    this.formularioEmp.get('empleadoSolicita').setValue('');
  }

  changeClearSolicitadosMul(event) {
    this.formularioEmpMultiple.get('departamentoSolicita').setValue('');
    this.formularioEmpMultiple.get('empleadoSolicita').setValue('');
  }

  changeClearEmpleadoMul() {
    this.formularioEmpMultiple.get('empleadoSolicita').setValue('');
  }

  changeEmpresaSolicitaMul() {
    if(this.formularioEmpMultiple.get('empresaSolicita').value === this.codEmpresa.codEmpresa){
      this.formularioEmpMultiple.get('departamentoSolicita').setValidators([Validators.required]);
      this.formularioEmpMultiple.get('empleadoSolicita').setValidators([Validators.required]);
      this.formularioEmpMultiple.get('departamentoSolicita').setValue('');
      this.formularioEmpMultiple.get('empleadoSolicita').setValue('');
      this.claseLabel = 'letrasDanger';
      this.depSolicita = 'Departamento Solicita*';
      this.empSolicitante = 'Empleado Solicitante*';
    } else {
      this.formularioEmpMultiple.get('departamentoSolicita').clearValidators();
      this.formularioEmpMultiple.get('empleadoSolicita').clearValidators();
      this.formularioEmpMultiple.get('departamentoSolicita').setValue('');
      this.formularioEmpMultiple.get('empleadoSolicita').setValue('');
      this.claseLabel = '';
      this.depSolicita = 'Departamento Solicita';
      this.empSolicitante = 'Empleado Solicitante';
    }
  }

  changeEmpresaSolicita(){
    if(this.formularioEmp.get('empresaSolicita').value === this.codEmpresa.codEmpresa){
      this.formularioEmp.get('departamentoSolicita').setValidators([Validators.required]);
      this.formularioEmp.get('empleadoSolicita').setValidators([Validators.required]);
      this.claseLabel = 'letrasDanger';
      this.depSolicita = 'Departamento Solicita*';
      this.empSolicitante = 'Empleado Solicitante*';
    } else {
      this.formularioEmp.get('departamentoSolicita').clearValidators();
      this.formularioEmp.get('empleadoSolicita').clearValidators();
      this.claseLabel = '';
      this.depSolicita = 'Departamento Solicita';
      this.empSolicitante = 'Empleado Solicitante';
    }
  }

  clearCmb(tag) {
    this.formularioEmp.get(tag).setValue('');  
  }
  clearCmbMul(tag) {
    this.formularioEmpMultiple.get(tag).setValue('');  
  }

}
